<template>
  <div class="container container-table">
      <div class="row vertical-10p">
        <div class="container">
          <!-- <img src="/static/img/logo_escrito.png" class="center-block logo"> -->
          <div class="text-center col-md-4 col-sm-offset-4">
            <!-- login form -->
            <form class="ui form loginForm"  @submit.prevent="checkCreds">

              <div class="input-group">
                <span class="input-group-addon"><i class="fa fa-envelope"></i></span>
                <input class="form-control" name="username" placeholder="Username" type="text" v-model="username">
              </div>

              <div class="input-group">
                <span class="input-group-addon"><i class="fa fa-lock"></i></span>
                <input class="form-control" name="password" placeholder="Password" type="password" v-model="password">
              </div>
              <router-link to="redefinir-senha">
                Esqueceu sua senha?
              </router-link><br><br>
              <button id="btn" type="submit" class="btn btn-primary btn-lg" >
                <div v-show="loading"><i class="fa fa-spinner fa-spin"></i>Entrando</div>
                <div v-show="!loading">Entrar</div>
              </button>
            </form>
            <!-- errors -->
            <div v-if="response" class="text-red"><p>{{response}}</p></div>
          </div>
        </div>
      </div>
  </div>
</template>

<script>
import firebase from 'firebase'
import router from '../router'
import $ from 'jquery'

export default {
  name: 'Login',
  data (router) {
    return {
      username: '',
      password: '',
      response: '',
      classeBtn: '',
      loading: false
    }
  },
  created () {
    
    
  },
  methods: {
    checkCreds () {
      this.loading = true
      firebase.auth().signInWithEmailAndPassword(this.username, this.password).then(
        (user) => {
          window.localStorage.setItem('usuario', JSON.stringify(user));
          router.replace('/admin')
        },
        (Error) => {
          this.loading = false
          this.response = Error.message
        }
      )
    }
  }
}
</script>

<style>
html, body, .container-table {
  height: 100%;
  /* background-color: #282B30 !important; */
}
.container-table {
    display: table;
    color: white;
}
.vertical-center-row {
    display: table-cell;
    vertical-align: middle;
}
.vertical-20p {
  padding-top: 20%;
}
.vertical-10p {
  padding-top: 10%;
}
.logo {
  width: 18em;
  padding: 1em;
}
.loginForm .input-group {
  padding-bottom: 1em;
  height: 4em;
}
.input-group input {
  height: 4em;
}

</style>
